<template>
  <el-header>
    <div class="title">
      <template v-if="project.settings?.showLogo === 'true'">
        <img style="width: 30px" v-if="project.settings.favicon.includes('.')" :src="logoUrl" />
        <svg-icon style="font-size: 30px" v-else :icon-class="project.settings.favicon" />
      </template>
      <span> {{ props.title }}</span>
    </div>
    <!-- 头部横向菜单 -->
    <slot></slot>
    <ToolControl v-if="props.menuDirectionType !== 'true'" flex-direction="row" />
  </el-header>
</template>

<script lang="ts" setup>
  import { genImgUrl } from '@haohan/clw-utils'
  import { useProject } from '@haohan/clw-store'
  import ToolControl from './ToolControl.vue'

  const projectStore = useProject()
  const project = projectStore.currentProject
  console.log('---', project.settings)
  const logoUrl = computed(() => {
    return genImgUrl(project, 'LOGO')
  })
  const props = defineProps({
    title: {
      type: String,
      default: ''
    },
    menuDirectionType: {
      type: String,
      required: true
    }
  })
</script>

<style lang="scss" scoped>
  .el-header {
    --el-header-height: 52px;
    --el-header-padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--custom-menu-bg-color);
    color: var(--custom-menu-text-color);
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);

    .title {
      min-width: 160px;
      font-size: 18px;
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }
</style>
